import { TAGS } from "../constants";
import { api } from "./api";

export const banApi = api.injectEndpoints({
  endpoints: (build) => ({
    banUser: build.mutation<void, { userId: string; reason: string }>({
      query: (data) => ({
        url: "/api/ban",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [TAGS.PATIENT],
    }),
  }),
});

export const { useBanUserMutation } = banApi;
